(ns machtfit.dashboard.stepchall.form.route-editor.shared)

(def route-editor-svg-id "route-editor-svg")

(def route-width 1080)
(def route-height 1500)

(def max-x 1000)
(def max-y (-> max-x
               (/ route-width)
               (* route-height)))
